import { RootState } from 'MyTypes';
import { createSelector } from 'reselect';

import { Organization } from '@portal/common/types';

export const getOrganization = (state: RootState): Organization => state.organization;

export const getOrganizationId = createSelector(
    getOrganization,
    (organization) => organization?.id
);
